import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSitemap } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchSitemap = createAsyncThunk(
  "sitemap/fetchSitemap",
  async (
    params: Partial<{ config?: object }>,
    { getState, rejectWithValue }
  ) => {
    const { token } = fetchAuthToken(getState());
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { config } = params;
      return await getSitemap(token, baseUrl, {}, config);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
